import artifact from '$houdini/artifacts/UpdateStore'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateStoreStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
